import type { FaireProductEntity } from "../../entity_types/product";

export const p_kaf4sgetrv: FaireProductEntity = {
  token: "p_kaf4sgetrv",
  type: "product",
  name: "Organic Macadamias with Sea Salt (4oz)",
  brandName: "Island Harvest",
  imageUrl:
    "https://cdn.faire.com/fastly/a4cfc6b538cef2be97174e2652eccb036625169d5c9692e2261bc477e3e4912f.jpeg",
  priceDollars: 5.25,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/e4fe8bfcabdab6924d3693ac14f8994733dc49d494b8d6edc7e43b6349841093.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
